import { types } from 'mobx-state-tree';

export const POLL_INTERVAL = 4000;
export const QR_LIFETIME_SECONDS = 870;

export const QR_AUTH_STEP = {
  // INITIAL: 'INITIAL',
  LOADING: 'LOADING',
  READY: 'READY',
  SCANNED: 'SCANNED',
  CONFIRMED: 'CONFIRMED',
  USED: 'USED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  ERROR: 'ERROR',
} as const;

export const QrAuthStageStatus = {
  MISS: 'miss',
  SCANNED: 'scanned',
  CONFIRMED: 'confirmed',
} as const;

export type QrAuthStep = (typeof QR_AUTH_STEP)[keyof typeof QR_AUTH_STEP];

export const QrAuthStageStatusType = types.enumeration(
  'QrAuthStageStatus',
  Object.values(QrAuthStageStatus) as [string, ...string[]]
);

export const ACTIVE_STEPS = new Set<QrAuthStep>([
  QR_AUTH_STEP.READY,
  QR_AUTH_STEP.SCANNED,
]);

export const QrCodeAuthStepType = types.enumeration(
  'QrCodeAuthStep',
  Object.values(QR_AUTH_STEP)
);
